import { render } from "./AppRadioButtons.vue?vue&type=template&id=b35c1ff6&scoped=true&ts=true"
import script from "./AppRadioButtons.vue?vue&type=script&lang=ts"
export * from "./AppRadioButtons.vue?vue&type=script&lang=ts"

import "./AppRadioButtons.vue?vue&type=style&index=0&id=b35c1ff6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35c1ff6"]])

export default __exports__